import { useEffect, useState } from "react";
import styles from "./CardBook.module.scss"

// Ambil teks dari field yang bisa berupa string, objek relasi, atau kosong
const toText = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value.trim();
    if (typeof value === 'object') return String(value.name ?? value.title ?? '').trim();
    return String(value).trim();
};

const CardBook = ({ image, title, typeBook, level, book }) => {
    const [imgSrc, setImgSrc] = useState(image);

    const invalidImageUrls = ['https://siplahtelkom.com/assets/images/no-image-available.jpg'];

    useEffect(() => {
        if (!image || invalidImageUrls.includes(image)) {
            setImgSrc('/assets/image/catalog/book-placeholder.jpg');
        } else {
            setImgSrc(image);
        }
    }, [image]);

    // Shuffle array content image for background cover book
    const ellipseArray = ['ellipse-1.png', 'ellipse-2.png', 'ellipse-3.png']
    const ellipseBackground = ellipseArray.sort(() => (Math.random() > 0.3) ? 1 : -1)

    // Info pelaku perbukuan: penulis jadi baris utama, fallback ke pelaku lain bila penulis kosong
    const penulis = toText(book?.writer) || toText(book?.author) || toText(book?.penulis);
    const otherContributor = [
        { label: 'Ilustrator', value: toText(book?.ilustrator) || toText(book?.illustrator) },
        { label: 'Penerjemah', value: toText(book?.translator) },
        { label: 'Editor', value: toText(book?.editor) },
    ].find((item) => item.value);
    const contributor = penulis
        ? { label: 'Penulis', value: penulis }
        : otherContributor || (book ? { label: 'Penulis', value: '-' } : null);

    // Info penerbit & tahun terbit
    const publisher = toText(book?.publisher);
    const rawYear = toText(book?.published_year) || toText(book?.publication_year) || toText(book?.year) || toText(book?.tahun_terbit);
    const year = (rawYear.match(/\d{4}/) || [''])[0];
    const publisherLine = [publisher, year].filter(Boolean).join(' · ');

    return (
        <div className={`card border-0 mt-3 ${styles.card}`}>
            <div className="card-header text-center text-lg-start bg-white p-0 border-0" style={{ backgroundImage: `url(/assets/image/home/${ellipseBackground[1]})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'bottom' }}>
                <div className={styles.bookContainer}>
                    <div className={styles.book}>
                        <img
                            src={imgSrc}
                            alt={title}
                            className={styles.bookCover}
                            onError={() => setImgSrc('/assets/image/catalog/book-placeholder.jpg')}
                        />
                        <div className={styles.coverGloss}></div>
                        <div className={styles.pageRightEdge}></div>
                    </div>
                </div>
            </div>
            <div className="card-body px-5 px-lg-0 py-2">

                {typeBook === 'pdf' && (<span className="badge rounded-pill bg-danger mt-2">PDF</span>)}
                {typeBook === 'audio' && (<span className="badge rounded-pill bg-success mt-2">Audio</span>)}
                {typeBook === 'interactive' && (<span className="badge rounded-pill bg-primary mt-2">Interaktif</span>)}
                {level && (<span className="badge rounded-pill bg-secondary mt-2 ms-1">{level}</span>)}

                <div className="my-2" title={title}>{title}</div>

                {(contributor || publisherLine) && (
                    <div className={styles.metaBlock}>
                        {contributor && (
                            <div className={styles.meta} title={`${contributor.label}: ${contributor.value}`}>
                                <span className={styles.metaLabel}>{contributor.label}:</span> {contributor.value}
                            </div>
                        )}
                        {publisherLine && (
                            <div className={styles.metaMuted} title={publisherLine}>{publisherLine}</div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default CardBook